// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"q4","left":"q5","center":"q6","right":"q7"};